import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{attrs:{"width":_vm.dimension}},[_c(VImg,{attrs:{"src":_vm.getImage(),"height":_vm.dimension,"width":_vm.dimension,"alt":""}}),_c(VCardTitle,{staticClass:"justify-center"},[_vm._v(_vm._s(_vm.name))]),_c(VCardSubtitle,[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }